import { MessageCircle } from "lucide-react";
import { CONTACT, waLink } from "../../config/site";

export const WhatsAppFloat = () => (
  <a
    href={waLink(CONTACT.whatsappPrimary, "Namaste! I'm interested in BIDC industrial plots.")}
    target="_blank"
    rel="noopener noreferrer"
    aria-label="Chat on WhatsApp"
    data-testid="whatsapp-float"
    className="wa-pulse fixed bottom-6 right-6 z-50 flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-lg transition-transform duration-200 hover:scale-105"
  >
    <MessageCircle className="h-6 w-6" strokeWidth={2} />
  </a>
);
